export default __webpack_public_path__ + "static/media/lion.a9f3ce28.png";